module.exports = __webpack_public_path__ + "img/top13.0.1.0_202608111507.png";